import { useEffect, useRef } from 'react';
import { Modal } from '../../Universal/NovusDSImports';
import { useReduxSelector, useReduxDispatch } from '../../Store/reduxHooks';
import { RootState } from '../../store';
import ReactPlayer from 'react-player';
import DOMPurify from 'dompurify';
import {
  getspecificdemoVideos,
  specificdemoVideosReceived
} from '../../Store/reducers/DemoVideos';
interface ViewModalProps {
  activeTab: string;
  customFooter?: React.ReactNode;
  selectedReleaseNote?: any;
  selectedDemoVideo?: any;
  setSelectedVideo?: (video: any) => void;
}

const ViewModal: React.FC<ViewModalProps> = (props) => {
  const {
    selectedReleaseNote,
    customFooter,
    activeTab,
    selectedDemoVideo,
    setSelectedVideo
  } = props;

  const dispatch = useReduxDispatch();
  const videoLink = useReduxSelector(
    (state: RootState) => state.DemoVideos.video_link
  );

  const videoTimer = useRef<NodeJS.Timeout | null>(null);

  const handleClick = (e): any => {
    if (
      !(e.target as Element)?.classList.contains('view-more-close-button') &&
      !(e.target as Element)?.classList.contains('read-more')
    ) {
      e.preventDefault();
      e.stopPropagation();
    }
  };

  useEffect(() => {
    document.addEventListener('click', handleClick);
    return () => {
      document.removeEventListener('click', handleClick);
    };
  }, []);

  useEffect(() => {
    if (videoLink && activeTab === 'DEMO_VIDEOS') {
      const urlObj = new URL(videoLink);
      const videoExpires: number = Number(
        urlObj.searchParams.get('X-Amz-Expires')
      );

      if (videoExpires && !isNaN(videoExpires)) {
        const timer = setTimeout(() => {
          dispatch(
            getspecificdemoVideos({
              params: { videoId: selectedDemoVideo?.id }
            })
          );
        }, videoExpires * 1000);

        videoTimer.current = timer;
      }
    }

    return () => {
      if (videoTimer.current) {
        clearTimeout(videoTimer.current);
        videoTimer.current = null;
      }
    };
  }, [videoLink, selectedDemoVideo?.id, activeTab, dispatch]);

  useEffect(() => {
    if (selectedDemoVideo && activeTab === 'DEMO_VIDEOS') {
      dispatch(
        getspecificdemoVideos({ params: { videoId: selectedDemoVideo.id } })
      );
    }

    return () => {
      dispatch(specificdemoVideosReceived({ video_link: null }));
      if (setSelectedVideo) setSelectedVideo(null);
    };
  }, [selectedDemoVideo, activeTab, dispatch, setSelectedVideo]);

  return activeTab === 'RELEASE_NOTES' ? (
    <>
      <div
        className="view-more-modal mx-4 mt-3"
        dangerouslySetInnerHTML={{
          __html: DOMPurify.sanitize(selectedReleaseNote?.release_notes || '')
        }}
      />
      {customFooter}
    </>
  ) : activeTab === 'DEMO_VIDEOS' && videoLink ? (
    <ReactPlayer
      url={videoLink}
      controls
      width="100%"
      height="100%"
      className="react-player d-flex flex-grow-1 overflow-auto"
      config={{
        file: {
          attributes: {
            controlsList: 'nodownload'
          }
        }
      }}
    />
  ) : null;
};

export default Modal(ViewModal);
